var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagnateWhite = function SvgMagnateWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 17"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 8.5,
    r: 8,
    stroke: "#F2F3F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F3F5",
    stroke: "#F2F3F5",
    strokeWidth: 1.526,
    d: "M8.67 6.983 9 5.97l.33 1.013c.142.439.55.735 1.01.735h1.066l-.862.627c-.373.27-.528.75-.386 1.188l.33 1.014-.863-.626a1.06 1.06 0 0 0-1.25 0l-.862.626.33-1.014a1.06 1.06 0 0 0-.387-1.188l-.863-.627H7.66c.461 0 .87-.297 1.012-.735Z"
  })));
};
export default SvgMagnateWhite;